import { useParams, Link } from 'react-router-dom';
import Shell from '../components/Shell';
import Seo from '../components/Seo';
import { PageHero, Section, CTA } from '../components/Pieces';
import { techCapabilities } from '../mock';
import { ArrowRight } from 'lucide-react';

export default function TechDetail() {
  const { slug } = useParams();
  const cap = techCapabilities.find(c => c.id === slug) || techCapabilities[0];
  return (
    <Shell>
      <Seo title={cap.title} description={cap.body} />
      <PageHero
        kicker="Technology"
        title={cap.title}
        sub={cap.body}
        breadcrumbs={[{ label: 'Technology', href: '/technology' }, { label: cap.title }]}
      />
      <Section bg="white">
        <div className="grid md:grid-cols-3 gap-5">
          {techCapabilities.filter(c => c.id !== cap.id).slice(0, 6).map((c) => (
            <Link key={c.id} to={`/technology/${c.id}`} className="mm-card p-6 block">
              <div className="mm-kicker mb-2">Capability</div>
              <h3 className="font-display text-lg font-bold text-[var(--mm-ink)]">{c.title}</h3>
              <p className="mt-2 text-sm text-[var(--mm-ink)]/70 leading-relaxed">{c.body}</p>
              <span className="mt-4 btn-ghost">Explore <ArrowRight className="w-4 h-4"/></span>
            </Link>
          ))}
        </div>
      </Section>
      <CTA title="Design capability into your programme." />
    </Shell>
  );
}
